/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { defineMessages } from 'react-intl'

export default defineMessages({
  disconnectModalTitle: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.title',
    defaultMessage: 'Disconnect cluster',
  },
  nameToConfirmFormRowLabel: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.name-to-confirm',
    defaultMessage: 'Type the cluster name to confirm',
  },
  deleteButtonLabel: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.disconnect',
    defaultMessage: 'Disconnect cluster',
  },
  mistypedResourceNameError: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.error',
    defaultMessage: 'The deployment name you typed does not match {name}',
  },
  modalCalloutTitle: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.callout.title',
    defaultMessage: 'Disconnecting a cluster cannot be reversed',
  },
  modalCalloutMessage: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.callout',
    defaultMessage:
      'This action cannot be undone and permanently deletes connection with the cluster {name}. If you ' +
      'proceed, your existing connected services will be disabled and you will lose any data within them.',
  },
  copyToClipboardMessage: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.copy-to-clipboard',
    defaultMessage: 'Copy cluster name to clipboard',
  },
  modalCancelButton: {
    id: 'ccm.clusters-table.disconnect-cluster.modal.cancel',
    defaultMessage: 'Cancel',
  },
})
